/** The circular italic mark introduced in the Throughline tutorial. */
export function BrandMark() {
  return (
    <svg className="brand-mark" aria-hidden="true" viewBox="0 0 72 72">
      <circle
        cx="36"
        cy="36"
        r="34.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M303 -21Q208 -21 164.0 17.5Q120 56 120 128Q120 151 123.0 171.5Q126 192 131 218L286 886H108L129 977H311L381 1270H561L493 977H772L751 886H474L346 335Q337 297 331.0 261.5Q325 226 325 201Q325 146 352.5 120.5Q380 95 452 95Q478 95 525.0 101.5Q572 108 598 118L581 45Q511 18 449.0 -1.5Q387 -21 303 -21Z"
        transform="translate(21.0039 58.2843) scale(0.034082 -0.034082)"
        fill="currentColor"
      />
    </svg>
  );
}
